import { useQuery } from '@tanstack/react-query'
import { performanceService } from '@/services/api/performanceService'
import { DEFAULT_REVIEW_CYCLE_CONFIG, type ReviewCycleConfig } from '@/lib/reviewPeriod'

/**
 * Live review-cycle boundary config (the date each year on which YEAREND begins).
 * Cached ~1h since it changes at most once a year. Falls back to the 1-August
 * default until loaded, so callers can use the result synchronously with
 * getCurrentReviewPeriod(date, cfg).
 */
export function useReviewCycleConfig(): ReviewCycleConfig {
  const { data } = useQuery({
    queryKey: ['review-cycle-config'],
    queryFn: () => performanceService.getReviewCycleConfig(),
    staleTime: 60 * 60 * 1000, // 1 hour
    retry: 1,
  })
  return data
    ? { h2_start_month: data.h2_start_month, h2_start_day: data.h2_start_day }
    : DEFAULT_REVIEW_CYCLE_CONFIG
}
